import log from 'salvo-lite/log'

class Quantity {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = Object.assign({
            event: 'click',
            inputField: elem.querySelector('[data-product-quantity]'),
            inputFieldMobile: document.querySelector('[data-product-quantity-mobile]'),
            increaseButton: elem.querySelector('[data-quantity-increase]'),
            decreaseButton: elem.querySelector('[data-quantity-decrease]')
        }, JSON.parse(this._elem.getAttribute('data-quantity') || '{}'))
        this.checkMinMax = this.checkMinMax.bind(this)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const {increaseButton, decreaseButton, inputFieldMobile, inputField} = this._data
        increaseButton.addEventListener('click', (e) => {
            e.preventDefault()
            inputField.value = parseInt(inputField.value) + 1
            this.checkMinMax()
        })
        decreaseButton.addEventListener('click', (e) => {
            e.preventDefault()
            inputField.value = parseInt(inputField.value) - 1
            this.checkMinMax()
        })
        inputFieldMobile.addEventListener('change', (e) => {
            e.preventDefault()
            inputField.value = parseInt(inputFieldMobile.value)
            this.checkMinMax()
        })
        inputField.addEventListener('keyup', this.checkMinMax)
    }

    checkMinMax () {
        const { inputField } = this._data
        if (parseInt(inputField.value) < inputField.min) {
            inputField.value = inputField.min
        } else if (inputField.max && parseInt(inputField.value) > inputField.max) {
            inputField.value = inputField.max
        } else {
            inputField.dispatchEvent(new Event('change'))
        }
    }
}

export default Quantity



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Quantity.js